import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeOpenText } from '@fortawesome/pro-solid-svg-icons';

import { post } from 'helpers/api';
import { fetchTranslation } from '../../../../helpers/i18n';
import { getProfileData } from '../../helpers/preview';

export default function VerifyEmail({ email, readonly, resendVerificationPath }) {
  const [emailResent, setEmailResent] = useState(false);
  const previewProfile = getProfileData();

  useEffect(() => {
    if (readonly) post(resendVerificationPath, { previewProfile, readonly });
  }, []);

  const resendEmail = () => {
    post(resendVerificationPath, { previewProfile, readonly }).then(() => {
      setEmailResent(true);
      setTimeout(() => setEmailResent(false), 5000);
    });
  };

  return (
    <div>
      <div className="text-center mb-3 text-branding">
        <FontAwesomeIcon icon={faEnvelopeOpenText} size="2x"/>
      </div>
      <h5 className="text-center mb-6">
        <strong>{fetchTranslation('verify_your_email_address')}</strong>
      </h5>
      <p>
        {fetchTranslation('we_just_sent_email_to')} <strong>{email}</strong>
      </p>
      <p>
        {fetchTranslation('we_need_to_verify_this_email')}
      </p>
      <p className="text-muted">
        <small>
          {fetchTranslation('verification_email_help_text')}
        </small>
      </p>
      <div className="text-center">
        <Button disabled={emailResent} variant="link" onClick={resendEmail}>
          {fetchTranslation('resend_verification_email')}
        </Button>
      </div>
      {emailResent && (
        <div className="animate__animated animate__fadeInUp text-branding text-center mt-3">
          {fetchTranslation('email_verification_resent')}
        </div>
      )}
    </div>
  );
}

VerifyEmail.propTypes = {
  email: PropTypes.string.isRequired,
  readonly: PropTypes.bool,
  resendVerificationPath: PropTypes.string.isRequired
};
